import React from "react";
import { label } from "@/constants";
import { useLang } from "@/i18n";

// Single-select chip group
export function ChipGroup({ options, value, onChange, testid }) {
  const { lang } = useLang();
  return (
    <div className="flex flex-wrap gap-2" data-testid={testid}>
      {options.map((o) => {
        const active = value === o.value;
        return (
          <button
            key={o.value}
            type="button"
            data-testid={`${testid}-${o.value}`}
            onClick={() => onChange(o.value)}
            className={`px-4 min-h-[44px] rounded-lg border text-sm font-medium transition-colors active:scale-95 ${
              active ? "bg-slate-800 text-white border-slate-800" : "bg-white text-slate-700 border-slate-200"
            }`}
          >
            {label(o, lang)}
          </button>
        );
      })}
    </div>
  );
}

// Multi-select chip group (value = array)
export function MultiChipGroup({ options, value = [], onChange, testid }) {
  const { lang } = useLang();
  const toggle = (v) => onChange(value.includes(v) ? value.filter((x) => x !== v) : [...value, v]);
  return (
    <div className="flex flex-wrap gap-2" data-testid={testid}>
      {options.map((o) => {
        const active = value.includes(o.value);
        return (
          <button
            key={o.value}
            type="button"
            data-testid={`${testid}-${o.value}`}
            onClick={() => toggle(o.value)}
            className={`px-4 min-h-[44px] rounded-lg border text-sm font-medium transition-colors active:scale-95 ${
              active ? "bg-emerald-600 text-white border-emerald-600" : "bg-white text-slate-700 border-slate-200"
            }`}
          >
            {label(o, lang)}
          </button>
        );
      })}
    </div>
  );
}

export function Counter({ value, onChange, min = 0, testid }) {
  return (
    <div className="inline-flex items-center gap-3" data-testid={testid}>
      <button
        type="button"
        data-testid={`${testid}-minus`}
        onClick={() => onChange(Math.max(min, (value || 0) - 1))}
        className="h-10 w-10 rounded-lg border border-slate-200 bg-white text-xl font-bold text-slate-700 active:scale-90"
      >−</button>
      <span className="w-8 text-center font-semibold text-lg" data-testid={`${testid}-value`}>{value || 0}</span>
      <button
        type="button"
        data-testid={`${testid}-plus`}
        onClick={() => onChange((value || 0) + 1)}
        className="h-10 w-10 rounded-lg border border-slate-200 bg-white text-xl font-bold text-emerald-600 active:scale-90"
      >+</button>
    </div>
  );
}

export function Section({ title, children, testid }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 space-y-3" data-testid={testid}>
      <h3 className="text-xs font-semibold uppercase tracking-wider text-slate-500 font-head">{title}</h3>
      {children}
    </div>
  );
}
